import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  /* Критические стили */
  :root {
    --primary-color: #FF4B8F;
    --secondary-color: #1ABC9C;
    --text-color: #2B2D42;
    --background-color: #FFFFFF;
  }

  /* Добавляем стили для мобильного сафари */
  @supports (-webkit-touch-callout: none) {
    body {
      /* Высота области статус-бара на iOS */
      padding-top: env(safe-area-inset-top);
    }

    /* Добавляем цветной фон под статус-бар */
    body::before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: env(safe-area-inset-top);
      background: #1ABC9C;
      z-index: 10000;
    }
  }

  /* Используем CSS переменные вместо хардкода цветов */
  body {
    color: var(--text-color);
    background: var(--background-color);
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    width: 100%;
    overflow-x: hidden;
    min-height: 100vh;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html {
    scroll-behavior: auto !important;
    scroll-padding-top: 80px;
  }
  
  button {
    appearance: none;
    -webkit-appearance: none;
  }

  // ... остальные стили ...
`; 